import { useQuery } from "@connectrpc/connect-query";
import { searchTokens } from "@uniswap/client-search/dist/search/v1/api-searchService_connectquery";
import { getNativeAddress } from "uniswap/src/constants/addresses";
import { uniswapPostTransport } from "uniswap/src/data/rest/base";
import { parseProtectionInfo, parseRestProtocolVersion, parseSafetyLevel } from "uniswap/src/data/rest/utils";
import { buildCurrency, buildCurrencyInfo, getCurrencySafetyInfo } from "uniswap/src/features/dataApi/utils";
import { SearchResultType } from "uniswap/src/features/search/SearchResult";
import { buildCurrencyId, currencyId, isNativeCurrencyAddress } from "uniswap/src/utils/currencyId";
export function useSearchTokensAndPoolsQuery({
  input,
  enabled = true,
  select
}) {
  return useQuery(searchTokens, input, {
    transport: uniswapPostTransport,
    enabled: !!input && enabled,
    select
  });
}
export function searchTokenToCurrencyInfo(token) {
  const { chainId, address, symbol, name, decimals, logoUrl, feeData } = token;
  const safetyLevel = parseSafetyLevel(token.safetyLevel);
  const protectionInfo = parseProtectionInfo(token.protectionInfo);
  const currency = buildCurrency({
    chainId,
    // TODO: backend currently returns 'ETH' for some native tokens, remove this check once BE fixes
    address: address === "ETH" ? getNativeAddress(chainId) : address,
    decimals,
    symbol,
    name,
    buyFeeBps: feeData?.buyFeeBps,
    sellFeeBps: feeData?.sellFeeBps
  });
  const safetyInfo = getCurrencySafetyInfo(safetyLevel, protectionInfo);
  if (!currency) {
    return null;
  }
  return buildCurrencyInfo({ currency, currencyId: currencyId(currency), logoUrl, safetyInfo });
}
export function searchPoolToPoolSearchResult(pool) {
  const protocolVersion = parseRestProtocolVersion(pool.protocolVersion);
  if (!pool.token0 || !pool.token1 || !protocolVersion) {
    return void 0;
  }
  const token0Address = isNativeCurrencyAddress(pool.chainId, pool.token0.address) ? getNativeAddress(pool.chainId) : pool.token0.address;
  const token1Address = isNativeCurrencyAddress(pool.chainId, pool.token1.address) ? getNativeAddress(pool.chainId) : pool.token1.address;
  return {
    type: SearchResultType.Pool,
    chainId: pool.chainId,
    poolId: pool.id,
    protocolVersion,
    hookAddress: pool.hookAddress,
    feeTier: pool.feeTier,
    token0CurrencyId: buildCurrencyId(pool.chainId, token0Address),
    token1CurrencyId: buildCurrencyId(pool.chainId, token1Address)
  };
}
